let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kM8Fz")).then(() => parcelRequire('537Fw'));